export const compactAuthConfig = authConfig =>
  Object.fromEntries(
    Object.entries(authConfig || {}).filter(
      ([, value]) => String(value || '').length > 0
    )
  );

export const hasAuthCredentialReplacement = authConfig =>
  Object.keys(compactAuthConfig(authConfig)).some(key => key !== 'location');

export const isCustomToolAuthConfigValid = ({
  authType,
  authConfig,
  preserveExistingSecret = false,
}) => {
  if (authType === 'none') return true;
  if (preserveExistingSecret && !hasAuthCredentialReplacement(authConfig)) {
    return true;
  }

  const config = compactAuthConfig(authConfig);
  if (authType === 'bearer') return Boolean(config.token);
  if (authType === 'basic') return Boolean(config.username && config.password);
  if (authType !== 'api_key' || !config.key) return false;

  if (config.location === 'header') {
    return /^[A-Za-z0-9][A-Za-z0-9-]*$/.test(config.name || '');
  }
  if (config.location === 'query') {
    return /^[A-Za-z_][A-Za-z0-9_]*$/.test(config.name || '');
  }
  return false;
};

export const buildCustomToolPayload = ({
  state,
  preserveExistingAuthSecret = false,
}) => {
  const payload = {
    ...state,
    param_schema: state.param_schema.map(param => ({ ...param })),
    auth_config: compactAuthConfig(state.auth_config),
  };

  if (state.auth_type === 'none') {
    payload.auth_config = {};
  } else if (
    preserveExistingAuthSecret &&
    Object.keys(payload.auth_config).every(key => key === 'location')
  ) {
    delete payload.auth_config;
  }

  return payload;
};
